import React from 'react';
import { Edit } from 'react-admin';
import TemplateForm from './form';

const TemplateEdit = (props) => {
  const { resource } = props;
  return (
    <Edit
      mutationMode="optimistic"
      title={`resources.${resource}.titles.edit`}
      {...props}
    >
      <TemplateForm/>
    </Edit>
  );
};

export default TemplateEdit;
